import script from "./AutomationActionEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./AutomationActionEditor.vue?vue&type=script&setup=true&lang=js"

import "./AutomationActionEditor.vue?vue&type=style&index=0&id=3febacae&lang=scss"

const __exports__ = script;

export default __exports__